import { render } from "./TzolkinComponent.vue?vue&type=template&id=684c2124&scoped=true"
import script from "./TzolkinComponent.vue?vue&type=script&lang=js"
export * from "./TzolkinComponent.vue?vue&type=script&lang=js"

import "./TzolkinComponent.vue?vue&type=style&index=0&id=684c2124&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684c2124"]])

export default __exports__